import _get from "lodash/get"
import _compact from "lodash/compact"
import { ERROR_STRATEGY } from "constant"

const configOption = {
  venueId: process.env.REACT_APP_VENUE_ID,
  projectId: process.env.REACT_APP_PROJECT_ID,
  themeName: process.env.REACT_APP_THEME_NAME,
  host: process.env.REACT_APP_API_HOST,
  apiKey: process.env.REACT_APP_API_KEY,
  venueExtension: _compact(
    (process.env.REACT_APP_VENUE_EXTENSION || "standard").split(",")
  ),
  device: process.env.REACT_APP_DEVICE,
  appType: process.env.REACT_APP_TYPE || "webapp",
  mapThemeName: process.env.REACT_APP_MAP_THEME_NAME,
  env: process.env.NODE_ENV,
  mobileBaseUrl: process.env.REACT_APP_MOBILE_BASE_URL,
  routerBasename: process.env.REACT_APP_ROUTER_BASENAME,
  userLocationStaleTime: process.env.REACT_APP_USER_LOCATION_STALE_TIME,
  appConfigId: process.env.REACT_APP_CONFIG_ID,
  i18nNameSpace: process.env.REACT_APP_I18N_NAME_SPACE,
  liveTrafficApiKey: process.env.REACT_APP_LIVE_TRAFFIC_API_KEY,
  googleAnalyticsTrackingId: process.env.REACT_APP_GTM_TRACKING_ID,
  googleAnalyticsSecretKey: process.env.REACT_APP_GTM_SECRET_KEY,
  splitrHost: process.env.REACT_APP_SPLITR_HOST,
  offlineMode: process.env.REACT_APP_OFFLINE_MODE === "true",
  // Define how Sentry handles errors: 'reload' or 'redirect_404' (default).
  defaultErrorStrategy:
    process.env.REACT_APP_DEFAULT_ERROR_STRATEGY || ERROR_STRATEGY.REDIRECT_404,
  navigationErrorStrategy:
    process.env.REACT_APP_NAVGIATION_ERROR_STRATEGY || ERROR_STRATEGY.DIALOG,
  // TODO: Remove this config after implementing feature flags for this project
  sectionFeatureFlag: process.env.REACT_APP_FEATURE_FLAG_SECTION === "true",
  escalator3dModelFeatureFlag:
    process.env.REACT_APP_FEATURE_FLAG_3D_ESCALATOR_MODEL === "true",
  breakpointsPreset: process.env.REACT_APP_BREAKPOINTS_PRESET || "default",
  /**
   * Supported shortest path strategies:
   * - legacy (default)
   * - venue-sdk
   */
  shortestPathStrategy:
    process.env.REACT_APP_SHORTEST_PATH_STRATEGY || "legacy",
}

const config = (key, defaultValue = undefined) => {
  return _get(configOption, key, defaultValue)
}

export default config
